<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title">نمایش مرخصی ها</h6>
          </div>
          <div class="row py-2">
            <div class="col-4">
              <button class="btn btn-outline-warning btn-block" :class="{ active: state=='process' }" @click="states('process')">درانتظارتایید</button>
            </div>
            <div class="col-4">
              <button class="btn btn-outline-danger btn-block" :class="{ active: state=='deactive' }" @click="states('deactive')">لغوشده</button>
            </div>
            <div class="col-4">
              <button class="btn btn-outline-success btn-block" :class="{ active: state=='complete' }" @click="states('complete')">تاییدشده</button>
            </div>
          </div>
          <div class="d-flex justify-content-center height" v-if="data==null">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">در حال بارگذاری ...</span>
            </div>
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>نوع</th>
                  <th>نام</th>
                  <th>شماره سازمانی</th>
                  <th>شروع</th>
                  <th>پایان</th>
                  <th>توضیح</th>
                  <th>مقدارمرخصی</th>
                  <th>وضعیت</th>
                  <th>تاریخ ثبت</th>
                  <th v-if="state=='process'">تنظیمات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(vacation , index) in data" :key="index">
                  <td>{{index+1}}</td>
                    <td>
                      <div v-if="vacation.type=='time'">
                        ساعتی
                      </div>
                      <div v-else>
                        روزانه
                      </div>
                    </td>
                  <td v-text="vacation.user.name"></td>
                  <td v-text="vacation.user.organizational_code"></td>
                  <td>
                    <div v-if="vacation.type==='time'">
                      {{vacation.startTime}}
                    </div>
                    <div v-else>
                      {{vacation.start}}
                    </div>
                  </td>
                  <td>
                    <div v-if="vacation.type==='time'">
                      {{vacation.finishTime}}
                    </div>
                    <div v-else>
                      {{vacation.finish}}
                    </div>
                  </td>
                  <td>{{vacation.description}}</td>
                  <td>
                    <div v-if="vacation.type==='time'">
                      {{vacation.diff}} ساعت
                    </div>
                    <div v-else>
                      {{vacation.diffH}} روز
                    </div>
                  </td>
                  <td>
                    <div v-if="!vacation.active">
                      <button class="btn btn-danger" disabled>لغو شده</button>
                    </div>
                    <div v-else-if="vacation.complete">
                      <button class="btn btn-success" disabled>تایید شده</button>
                    </div>
                    <div v-else-if="vacation.manager_id && !vacation.boss_id">
                      <button class="btn btn-warning" disabled>درانتظار تایید رئیس</button>
                    </div>
                    <div v-else-if="!vacation.manager_id && vacation.boss_id">
                      <button class="btn btn-warning" disabled>درانتظار تایید مدیر</button>
                    </div>
                    <div v-else>
                      <button class="btn btn-warning" disabled>درانتظار تایید</button>
                    </div>
                  </td>
                  <td v-text="vacation.date"></td>
                  <td v-if="state=='process'">
                    <div class="btn-group">
                      <button class="btn btn-outline-success" v-if="vacation.active && !(boss && vacation.boss_id) && !(manager && vacation.manager_id)" @click="accept(vacation.id)">تایید</button>
                      <button class="btn btn-success" v-else disabled>تایید شده</button>
                      <button class="btn btn-outline-danger" v-if="vacation.active && !(vacation.status)" @click="deActive(vacation.id)">لغو</button>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>ردیف</th>
                  <th>نوع</th>
                  <th>نام</th>
                  <th>شماره سازمانی</th>
                  <th>شروع</th>
                  <th>پایان</th>
                  <th>توضیح</th>
                  <th>مقدارمرخصی</th>
                  <th>وضعیت</th>
                  <th>تاریخ ثبت</th>
                  <th v-if="state=='process'">تنظیمات</th>
                </tr>
              </tfoot>
            </table>
            <paginations :count="pagination.count" :current="pagination.currentPage" v-on:pages="page"></paginations>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination.js'
import paginations from '@/components/partials/paginations.vue'
export default {
  name: 'VacationsIndex',
  mixins: [pagination],
  components: {
    paginations
  },
  data () {
    return {
      data: null,
      state: 'process',
      url: '/api/vacations/state/process',
      manager: false,
      boss: false
    }
  },
  beforeCreate () {
    this.$send.submit('get', 'api/vacations/get/roles')
      .then(response => {
        this.manager = response.manager
        this.boss = response.boss
      })
  },
  methods: {
    states (state) {
      this.url = '/api/vacations/state/' + state
      this.state = state
      this.start()
    },
    deActive (id) {
      this.$send.submit('delete', 'api/vacations/' + id)
        .then(response => {
          this.start()
        })
    },
    accept (id) {
      this.$send.submit('get', 'api/vacation/accept/' + id)
        .then(response => {
          const num = this.data.findIndex(x => x.id === response.id)
          this.data[num].manager_id = response.manager_id
          this.data[num].boss_id = response.boss_id
        })
    }
  }
}

</script>
